import React from 'react';
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Divider
} from '@mui/material';
import closeIcon from '../../assets/icons/closeIcon.svg';

export const InfoPopup = ({ onClose }: { onClose: () => void }) => {
  return (
    <Box
      sx={{
        maxWidth: 400,
        padding: '1rem',
        borderRadius: '0.9375rem',
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        gap: '0.625rem',
        display: 'flex',
        flexDirection: 'column'
      }}
      component={Paper}
    >
      <Button sx={{ justifyContent: 'end' }} onClick={onClose}>
        <img src={closeIcon} alt="Close" />
      </Button>
      <Typography
        align="center"
        sx={{
          fontSize: '1rem',
          fontWeight: 450,
          lineHeight: '1.4375rem',
          textTransform: 'uppercase',
          color: '#002A3A'
        }}
      >
        Estimated weights for volumes for ascites and peripheral oedema
      </Typography>
      <TableContainer>
        <Table>
          <TableHead
            sx={{
              backgroundColor: '#F2F2F2'
            }}
          >
            <TableRow sx={{ height: '45px' }}>
              <TableCell
                sx={{
                  height: '1.5625rem',
                  borderLeft: '0.0625rem solid #D9D9D6',
                  borderRight: '0.0625rem solid #D9D9D6',
                  borderTop: '0.0625rem solid #D9D9D6'
                }}
              ></TableCell>
              <TableCell
                sx={{
                  fontSize: '1rem',
                  fontWeight: 450,
                  lineHeight: '1.4375rem',
                  color: '#002A3A',
                  height: '1.5625rem',
                  borderLeft: '0.0625rem solid #D9D9D6',
                  borderRight: '0.0625rem solid #D9D9D6',
                  borderTop: '0.0625rem solid #D9D9D6'
                }}
              >
                Ascites
              </TableCell>
              <TableCell
                sx={{
                  fontSize: '1rem',
                  fontWeight: 450,
                  lineHeight: '1.4375rem',
                  color: '#002A3A',
                  height: '1.5625rem',
                  borderLeft: '0.0625rem solid #D9D9D6',
                  borderRight: '0.0625rem solid #D9D9D6',
                  borderTop: '0.0625rem solid #D9D9D6'
                }}
              >
                Oedema
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow
              sx={{
                fontSize: '1rem',
                fontWeight: 450,
                lineHeight: '1.4375rem',
                color: '#002A3A'
              }}
            >
              <TableCell
                sx={{
                  borderLeft: '0.0625rem solid #D9D9D6',
                  borderRight: '0.0625rem solid #D9D9D6'
                }}
              >
                Minimal
              </TableCell>
              <TableCell
                sx={{
                  fontFamily: 'Calibri',
                  borderLeft: '0.0625rem solid #D9D9D6',
                  borderRight: '0.0625rem solid #D9D9D6'
                }}
              >
                2.2kg
              </TableCell>
              <TableCell
                sx={{
                  fontFamily: 'Calibri',
                  borderLeft: '0.0625rem solid #D9D9D6',
                  borderRight: '0.0625rem solid #D9D9D6'
                }}
              >
                1.0kg
              </TableCell>
            </TableRow>
            <TableRow
              sx={{
                fontSize: '1rem',
                fontWeight: 450,
                lineHeight: '1.4375rem',
                color: '#002A3A'
              }}
            >
              <TableCell
                sx={{
                  borderLeft: '0.0625rem solid #D9D9D6',
                  borderRight: '0.0625rem solid #D9D9D6'
                }}
              >
                Moderate
              </TableCell>
              <TableCell
                sx={{
                  fontFamily: 'Calibri',
                  borderLeft: '0.0625rem solid #D9D9D6',
                  borderRight: '0.0625rem solid #D9D9D6'
                }}
              >
                6.0kg
              </TableCell>
              <TableCell
                sx={{
                  fontFamily: 'Calibri',
                  borderLeft: '0.0625rem solid #D9D9D6',
                  borderRight: '0.0625rem solid #D9D9D6'
                }}
              >
                5.0kg
              </TableCell>
            </TableRow>
            <TableRow
              sx={{
                fontSize: '1rem',
                fontWeight: 450,
                lineHeight: '1.4375rem',
                color: '#002A3A'
              }}
            >
              <TableCell
                sx={{
                  borderLeft: '0.0625rem solid #D9D9D6',
                  borderRight: '0.0625rem solid #D9D9D6'
                }}
              >
                Severe
              </TableCell>
              <TableCell
                sx={{
                  fontFamily: 'Calibri',
                  borderLeft: '0.0625rem solid #D9D9D6',
                  borderRight: '0.0625rem solid #D9D9D6'
                }}
              >
                14.0kg
              </TableCell>
              <TableCell
                sx={{
                  fontFamily: 'Calibri',
                  borderLeft: '0.0625rem solid #D9D9D6',
                  borderRight: '0.0625rem solid #D9D9D6'
                }}
              >
                10.0kg
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
      <Divider sx={{ width: '100%', paddingTop: '0.625rem' }} />
      <Typography
        align="left"
        sx={{
          fontFamily: 'CalibriBoldItalic',
          fontSize: '1rem',
          lineHeight: '1.25rem',
          color: '#004F71'
        }}
      >
        Reference:
      </Typography>
      <Typography
        align="left"
        sx={{
          fontFamily: 'CalibriBold',
          fontSize: '1rem',
          lineHeight: '1.25rem',
          color: '#004F71'
        }}
      >
        Irish Nutrition and Dietetic Institute (2022) Nutrition Support
        Reference Guide.
      </Typography>
    </Box>
  );
};
